module.exports = __webpack_public_path__ + "img/ORDER-JP.84aa510d.png";